export function getUrlParameter( name ) {
	name = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' )
	let regex = new RegExp( '[\\?&]' + name + '=([^&#]*)' )
	let results = regex.exec( location.search )

	return results === null ? '' : decodeURIComponent( results[1].replace( /\+/g, ' ' ) )
}

// https://stackoverflow.com/a/1634841
export function removeURLParameter( parameter ) {
	var url = window.location.href
	var urlparts = url.split( '?' )

	if ( urlparts.length >= 2 ) {
		var prefix = encodeURIComponent( parameter ) + '='
		var pars = urlparts[1].split( /[&;]/g )

		// Reverse iteration as may be destructive.
		for ( var i = pars.length; i-- > 0; ) {
			// Idiom for string.startsWith>
			if ( pars[ i ].lastIndexOf( prefix, 0 ) !== -1 ) {
				pars.splice( i, 1 )
			}
		}

		url = urlparts[0] + ( pars.length > 0 ? '?' + pars.join( '&' ) : '' )
	}

	window.history.replaceState( {}, '', url )
}

export function validateEmail( email ) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

	return re.test( email )
}



// WEBPACK FOOTER //
// ./utilities/url.jsx